/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Swift_Calm_Deer_PickInputs */

const en_swift_calm_deer_pick = /** @type {(inputs: Swift_Calm_Deer_PickInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const de_swift_calm_deer_pick = /** @type {(inputs: Swift_Calm_Deer_PickInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ausgewählt`)
};

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Swift_Calm_Deer_PickInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const swift_calm_deer_pick = /** @type {((inputs: Swift_Calm_Deer_PickInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Calm_Deer_PickInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_swift_calm_deer_pick(inputs)
	return de_swift_calm_deer_pick(inputs)
});